import moment from "moment";
import React, { useEffect, useState } from "react";
import Button from "../../../components/Button";
import Input from "../../../components/Input";
import Modal from "../../../components/Modal";
import { ModalDelete } from "../../../components/ModalDelete";
import Table from "../../../components/Table";
import { convertIntToMoney } from "../../../helpers/conversions";
import { renderError } from "../../../helpers/errors";
import api from "../../../services/api";

const OrderNfsTab = ({order}) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({rows: [], header:[]});
    const [showCreateNf, setShowCreateNf] = useState(false);
    const [nfToDelete, setNfToDelete] = useState(null);

    useEffect(() => {
        generateData();
    }, [order]);

    const generateData = () => {
        const header = ['Cadastrada em', 'Documento', ''];
        const rows = [];
        
        order.nfs.map(nf => {
            rows.push({
                data: [
                    moment(nf.created_at).format('DD/MM/YYYY HH:mm'),
                    <a href="#">Download</a>
                ],
                action: () => window.open(nf.file_url),
                buttons: [
                    <Button type={`delete`} svg={`delete`} action={() => setNfToDelete(nf.id)} />
                ]
            });
        });

        setData({header, rows});
    }

    const storeNf = () => {
        let form = new FormData();
        let el = document.getElementById('file');
        let file = el.files[0];

        if(file === undefined){
            alert('Você precisa informar um arquivo');
            return;
        }

        form.append('order_id', order.id);
        form.append('file', file);
        
        api.post(`/order/nf`, form, { 
            headers: {
                "Content-Type": "multipart/form-data"
            }
        }).then(res => {
            window.location.reload();
        }).catch(error => {
            renderError(error);
        }).then(() => setLoading(false));
    }

    const deleteNf = () => {
        setLoading(true);
        api.delete(`/order/nf/${nfToDelete}`)
            .then(res => {
                window.location.reload();
            }).catch(error => {
                renderError(error);
            }).then(() => {
                setLoading(false);
                setNfToDelete(null);
            });
    }

    return (
        <>
            <ModalDelete
                show={nfToDelete !== null}
                close={() => setNfToDelete(null)}
                action={deleteNf}
                loading={loading}
            />
            <Modal 
                show={showCreateNf}
                close={() => setShowCreateNf(false)}
                title={`Cadastrar nota fiscal`}
                footer={
                    <>
                        <Button
                            type={`primary`}
                            size={`small`}
                            text={'Cadastrar'}
                            svg={`save-white`}
                            action={storeNf}
                            loading={loading} 
                        />
                    </>
                }
            >
                <div className="section">
                    <input type="file" id="file" />
                </div>
            </Modal>
            <div className="row">
                <div className="col">
                    <Button 
                        type={`secondary`}
                        size={`small`}
                        text={`Cadastrar nota fiscal`}
                        action={() => setShowCreateNf(true)}
                    />
                    <br />
                </div>
            </div>
            <Table rows={data.rows} header={data.header} loading={loading} />
        </>
    );
} 

export default OrderNfsTab;